<template lang="html">
    <div class="container" id="text-page">
      
      <div v-if="status != 'failure'">
        <div style="text-align: center;font-size: 18px;">
            <img src="/public/images/circlecheck.png" width="30%">
        </div>
       
        <br>

        <p style="text-align: center;">TU PEDIDO HA SIDO EXITOSO!<br> 
            Número de pedido:<b> EUM000{{ order_id }}</b>
        </p>

        <div class="col-12 text-center" style="padding-top: 20px;" >
            <b-button class="btn btn-success" slot="button" @click="toHome">Regresar a Home <i class="color-white fas fa-home"></i></b-button>
            <b-button class="btn btn-primary" slot="button" @click="toHistorty()">Ir a mis compras <i class="color-white fas fa-clipboard-list"></i></b-button>
          </div>

      </div>
      <div v-else>
        <div style="text-align: center;">
            <img src="/public/images/circlerror.png" width="30%">
        </div>
        <p style="text-align: center;font-size: 18px;">Ocurrio un error al procesar tu pedido
        </p>
      </div>
      <sweet-modal ref="modalLoading">
        <div class="fa-3x" ><i class="fas fa-spinner fa-pulse"></i></div><br/>
        <div>Cargando ...</div>
        
      </sweet-modal>

    </div>

    
  </template>
  
  <script>
  export default {
    data() {
      return {
        order_id:null,
        status:null,
      }
    },
    methods:{
      
        getRow(){
            this.$refs.modalLoading.open();
            axios.post(tools.url('/api/mercadopago/check-status'),{preference_id:this.$route.query.preference_id,payment_id:this.$route.query.payment_id,status:this.$route.query.status}).then((response)=>{
                this.$refs.modalLoading.close();
                this.status = response.data.status;
                if(response.data.status != 'failure'){
                    this.order_id=response.data.order_id;
                }
                else{

                }
              
          
            }).catch((error)=>{
                this.status = 'failure';
                this.$refs.modalLoading.close();
          });
        },
        toHome(){
           
            this.$router.push('/');
        },
        toHistorty(){
          this.$router.push('/usuario/pedidos');
          
        },
    },
    mounted(){
        
        this.getRow();
    }
  }
  </script>